module.exports = __webpack_public_path__ + "img/cpzljc.76491e5a.png";